var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.74,
    height: 61.74,
    viewBox: "0 0 61.74 61.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "error_FILL0_wght400_GRAD0_opsz48_1_",
    "data-name": "error_FILL0_wght400_GRAD0_opsz48 (1)",
    d: "M32.786,38.5h4.631V18.972H32.786ZM34.87,50.305a2.5,2.5,0,1,0-1.814-.733A2.463,2.463,0,0,0,34.87,50.305Zm0,15.435a31.311,31.311,0,0,1-12.194-2.354A29.878,29.878,0,0,1,6.354,47.064,31.31,31.31,0,0,1,4,34.87,31.11,31.11,0,0,1,6.354,22.754a30.129,30.129,0,0,1,6.521-9.8A30.776,30.776,0,0,1,34.87,4,30.623,30.623,0,0,1,65.74,34.87a30.776,30.776,0,0,1-8.952,21.995,30.129,30.129,0,0,1-9.8,6.521A31.11,31.11,0,0,1,34.87,65.74Zm0-30.87Zm0,26.24a25.261,25.261,0,0,0,18.522-7.718A25.261,25.261,0,0,0,61.11,34.87a25.261,25.261,0,0,0-7.718-18.522A25.261,25.261,0,0,0,34.87,8.631a25.261,25.261,0,0,0-18.522,7.718A25.261,25.261,0,0,0,8.631,34.87a25.261,25.261,0,0,0,7.718,18.522A25.261,25.261,0,0,0,34.87,61.11Z",
    transform: "translate(-4 -4)",
    fill: "#d51b15"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorBox);
export default __webpack_public_path__ + "static/media/error-box.1d602e5dac3980cbc1bb62ebf1326c38.svg";
export { ForwardRef as ReactComponent };